import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { Button } from 'tdesign-react';
import { isEmpty, uniqBy } from 'lodash';
import { produce } from 'immer';
import Tip from '@/components/Tip';
import { isVoid } from '@/utils/common';
import Modal from '../Modal';
import { getDependVariable } from '..';
import VariableTable from './VariableTable';

export default function IpVariables({
  scopeType,
  hosts,
  ipVariables,
  setIpVariables,
  variables,
  descTitle,
}) {
  const [visible, setVisible] = useState(false);

  // 如果有依赖，检查依赖的值是否符合条件，不符合则剔除
  const filteredIpVariables = useMemo(
    () =>
      ipVariables.filter((item) => {
        const { dependId } = item;
        if (!isVoid(dependId)) {
          const depended = getDependVariable(variables, dependId);
          if (depended && String(item.dependValue) !== String(depended.defaultValue)) {
            return false;
          }
        }
        return true;
      }),
    [ipVariables, variables],
  );

  const selectedVariables = useMemo(() => {
    return filteredIpVariables.filter((item) => item.tagSelect);
  }, [filteredIpVariables]);

  // 剩余可选变量, 需要去重，选择时不关心主机
  const canSelectVariables = useMemo(() => {
    return uniqBy(
      filteredIpVariables.filter((item) => !item.tagSelect),
      'key',
    );
  }, [filteredIpVariables]);

  const handleClose = (keys) => {
    if (!isEmpty(keys)) {
      const nextVariables = produce(ipVariables, (draft) => {
        keys.forEach((key) => {
          // 标记所有
          draft.map((element) => {
            if (element.key === key) {
              element.tagSelect = true;
            }
          });
        });
      });
      setIpVariables(nextVariables);
    }
    setVisible(false);
  };

  const doDelete = (key) => {
    const nextVariables = produce(ipVariables, (draft) => {
      draft.forEach((item) => {
        if (item.key === key) {
          item.tagSelect = false;
          item.defaultValue = item.originValue; // 恢复备份
        }
      });
    });
    setIpVariables(nextVariables);
  };

  return (
    <>
      <Header>
        <Title content='IP级别变量表示每个IP的变量值不同（例如本机ip地址）'>IP级别变量</Title>
        <Button theme='primary' variant='outline' size='small' onClick={() => setVisible(true)}>
          添加可选变量
        </Button>
      </Header>
      {scopeType === 0 &&
        hosts.map((host) => (
          <VariableTable
            key={host.id}
            host={host}
            descTitle={descTitle}
            ipVariables={selectedVariables}
            setIpVariables={setIpVariables}
            doDelete={doDelete}
            variables={variables}
          />
        ))}
      <Modal variables={canSelectVariables} visible={visible} handleClose={handleClose} />
    </>
  );
}

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 33px;
  margin-top: 12px;
  padding-right: 10px;
`;

const Title = styled(Tip)`
  color: var(--td-text-color-primary);
  font-size: 14px;
  font-weight: bold;
  display: flex;
`;
